<template>
  <div
    class="im-main-container"
    ref="imContainerRef"
    :style="{
      ...customStyle,
      'margin-top': marginTop
    }"
    :class="[
      inIframe?'im-in-frame':'im-not-in-frame',
      (slideOpen || !(styleConfig && styleConfig.isUseWebSidebar) || isMiniMode) &&'card-info-hide'
    ]"
  >
      <div class="im-msg-container">
        <pc-header
          class="im-title-bar drag-title-inIframe"
          :style="inIframe && iframeIMStatus === 'close'?'height:50px':''"
          :isMinify="inIframe && iframeIMStatus === 'close'" :unReadMsgNum="unReadSum"
          :title-name="companyInfo.companyName"
          :inIframe="inIframe"
          :wpaDetail="wpaDetail"
        >
          <template #extra>
            <div
              class="btn-callqq"
              :class="{iframe: inIframe}"
              v-if="showQQ"
              @click="handleLunchQQ"
            >
              <img class="qq-icon" v-if="inIframe" src="@/static/img/qq-white.svg" />
              <img class="qq-icon" v-else src="@/static/img/qq.svg" />
            </div>
            <div
              class="toggle-card-info"
              v-if="isRenderSidebar"
              @click="handleCardInfo"
            >
            <img class="slide-icon" v-show="slideOpen" src="@/static/img/open-slide.svg" />
            <img class="slide-icon" v-show="!slideOpen" src="@/static/img/close-slide.svg" />
          </div>
          </template>
        </pc-header>

        <!-- AIO -->
        <aio
          ref="aio"
          :inIframe="inIframe"
          :aioBgImg="pcBgImage"
          :toolButtons="toolButtonsForPC"
          :serviceInfoShowType="linkInfo.openName"
          :wpaDetail="wpaDetail"
          :authConf="authConf"
          :guidanceInfo="guidanceInfo"
          :companyInfo="companyInfo"

          :messageList.sync="messageList"
          :notReadNumber.sync="notReadNumber"
          :reception.sync="reception"
          :inputContent.sync="inputContent"

          @clickToolBtn="clickToolBtn"
          @receiveNewMessage="onReceiveMsg"
          @onLunchQQ="handleLunchQQ"
          @onAddQQ="handleAddQQ"
          @ready="aioReady = true"
          @sessionStart="onSessionStart"
          @notifyRtc="handleNotifyRtc"
          @error="handleAioError"
        >
        <!-- 消息列表上方slot -->
        <template #beforeMsgList>
          <!-- 客服免费版提示 start -->
          <KefuFreeTip
            v-if="isShowKeSafeTip && showInfo && showInfo.isShowSafetyTips && !isMiniMode"
            @onClose="isShowKeSafeTip = false"
          />
          <!-- 客服免费版提示 end -->
          <!--公告区，权限控制isUseWebNotice -->
          <announcement-notice v-if="styleConfig.isUseWebNotice" :wpaDetail="wpaDetail" />
        </template>
        <!--
          自定义消息项slot。
          如果重写了自定义消息slot，那最后一项应该使用 msg-unknown兜底。
        -->
        <!-- <template #thirdMsgItem="slotProps">
          消息数据：{{ slotProps.data }}
          <msg-third-msg v-if="['aaa', 'bbb'].indexOf(slotProps.data.thirdType)>-1"
            :data="slotProps.data"></msg-third-msg>
          <msg-unknown v-else :data="slotProps.data">[未知类型消息]</msg-unknown>
        </template> -->
        <!-- 消息列表下方slot -->
        <template #afterMsgList>
          <QuickOrderCard :sessionStart="sessionStart" :wpaDetail="wpaDetail" :authConf="authConf"/>
          <message-bubble v-if="hasBubble"
            :bubbleConfig="bubbleConfig"
          />
          <msg-auto-complete v-if="configToAutoMsg.enable"
            :config="configToAutoMsg"
            :inputContent="inputContent"
            @onSelected="onMsgAutoCompleteSelected" ></msg-auto-complete>
        </template>
        <template #last>
          <!-- 商品列表 -->
          <GoodsList  :ecQuickMenu="ecQuickMenu" :wpaDetail="wpaDetail" v-model="goodsListShow"  ></GoodsList>
          <!-- 订单列表 -->
          <OrderList :ecQuickMenu="ecQuickMenu" :wpaDetail="wpaDetail" v-model="orderListShow"></OrderList>
        </template>
      </aio>
      </div>
      <div
        class="im-custom-container"
        v-if="isRenderSidebar"
        v-show="!slideOpen"
      >
        <!-- 暂时 iframe 地址 先写死 -->
        <iframe
          ref="infoCardIframeRef"
          scrolling="no"
          :src="iframeSrc"
        ></iframe>
      </div>
      <!-- 音视频响铃 -->
      <PcRing ref="videoRing" :wpaDetail="wpaDetail" :employeeInfo="employeeInfo"></PcRing>
  </div>
</template>

<script>
import MixinUi from '@/components-business/MixinUi';
import MixinPcVideo from '@/components-business/Video/js/mixins/pc';
import PcHeader from '@/components-business/PcHeader';
import KefuFreeTip from '@/components-business/KefuFreeTip';
import Aio from '@/components-aio/pc/Aio';
import queryString from 'query-string';
import AnnouncementNotice from '@/components-business/AnnouncementNotice';
import { debounce } from '@tencent/qd-lib';
import PcRing from '@/components-business/Video/pcRing.vue';

export default {
  name: 'WebIMPage',
  mixins: [MixinUi, MixinPcVideo],
  components: {
    PcHeader,
    Aio,
    KefuFreeTip,
    AnnouncementNotice,
    PcRing,
  },
  data() {
    return {
      slideOpen: false,
      isShowKeSafeTip: true,
      sessionStart: false,
      marginTop: 'calc((100vh - 600px) / 2)',
    };
  },

  mounted() {
    this.adjustIMWindowSize();
  },
  computed: {
    isRenderSidebar() {
      const renderCond = [
        this.wpaDetail.kfuin, // 有主号
        !this.inIframe, // 没有在iframe中
        this.styleConfig && this.styleConfig.isUseWebSidebar, // 不是免费版
        !this.isMiniMode, // 不是mini模式
      ];


      return renderCond.every(Boolean);
    },
    iframeSrc() {
      const urlParamsText = queryString.stringify({
        kfuin: this.wpaDetail.kfuin,
        wpaId: this.wpaDetail.wpaId,
        key: this.wpaDetail.key,
      });
      const extuinText = queryString.stringify({
        extuin: this.currExtuin || '',
      });
      return `./info-card.html?${urlParamsText}#${extuinText}`;
    },
    isMiniMode() {
      /* eslint-disable camelcase */
      const { mini_mode } = queryString.parse(location.search);
      return mini_mode === '1';
    },
  },

  methods: {
    handleCardInfo() {
      this.slideOpen = !this.slideOpen;
    },
    adjustIMWindowSize() {
      /** 这里webim窗口根据页面的宽度和高度，会在一个范围内进行自动缩放，
       * 所以没办法通过flex，定位等保持垂直居中，这里使用js来计算实现垂直居中，
       * 考虑缩放不属于频繁的场景，暂时不考虑debounce
       * */
      const imContainerEl = this.$refs.imContainerRef;
      this.marginTop = `calc((100vh - ${imContainerEl.clientHeight}px) / 2)`;
      window.addEventListener('resize', debounce(() => {
        this.marginTop = `calc((100vh - ${imContainerEl.clientHeight}px) / 2)`;;
      }, 100));
    },
    onSessionStart() {
      this.handleSessionStart();
    },
  },
};
</script>

<style lang="less" scoped>
.im-main-container{
  border-radius: 6px;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: row;
  overflow: hidden;
  background: #fff;
}
.im-in-frame .im-msg-container{
  max-width: 100%;
}
.im-not-in-frame .im-msg-container{
  max-width: 719px;
}
.im-msg-container{
  flex:1;
  display: flex;
  flex-direction: column;
  position: relative;
}
.im-not-in-frame{
  @width: 960px;
  @min-width: 730px;
  max-width: @width;
  min-width: @min-width;
  height: 600px;
  max-height: 100vh;
  margin: 0 auto;
  &.card-info-hide {
    max-width: calc(@width - 240px);
    min-width: calc(@min-width - 240px);
  }

  .im-title-bar{
    height: 44px;
    padding: 0 10px 0 12px;
    border-bottom: 1px solid #efeff4;
    line-height: 44px;
  }
}
.im-in-frame{
  width: 360px;
  height: 100%;
  max-height: 710px;

  .im-title-bar{
    max-width: 360px;
    height: 46px;
    padding-left: 19px;
    line-height: 46px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    padding-right: 8px;
  }
}

.toggle-card-info {
    cursor: pointer;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 3px;
    &:hover {
      background: rgba(36, 56, 97, 0.05);
    }
    &:active {
      background: #F1F6FF;
    }
}
.btn-callqq {
  width: 32px;
  height: 32px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  &:hover {
    background: rgba(36, 56, 97, 0.05);
  }
  &:active {
    background: #F1F6FF;
  }
  &.iframe {
    border-radius: 8px;
    &:hover {
      background: rgba(0, 0, 0, .1);
    }
  }
}

.im-custom-container{
  width: 240px;
  height: 100%;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  border-left: 1px solid #efeff4;
  overflow: auto;
  iframe {
    border: 0;
    width: 100%;
    min-height: 100%;
    display: block;
    overflow: hidden;
  }
}
</style>

